module.exports = __webpack_public_path__ + "static/media/dragAndDrop-step1.d7232c82.png";